var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "20 20 60 60",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1755 31.1807C28.4982 30.4622 29.2124 30 30 30H70C70.7876 30 71.5018 30.4622 71.8245 31.1807C72.1471 31.8992 72.0181 32.7401 71.4948 33.3287L56 50.7604V68C56 68.7575 55.572 69.4501 54.8944 69.7889C54.2169 70.1276 53.406 70.0545 52.8 69.6L44.8 63.6C44.2964 63.2223 44 62.6295 44 62V50.7604L28.5052 33.3287C27.9819 32.7401 27.8529 31.8992 28.1755 31.1807ZM34.4537 34L47.4948 48.6713C47.8202 49.0374 48 49.5102 48 50V61L52 64V50C52 49.5102 52.1798 49.0374 52.5052 48.6713L65.5463 34H34.4537Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.6aa7f2e8.svg";
export { ForwardRef as ReactComponent };